export default "__VITE_ASSET__Czn8PJTR__"